import { TESTIMONIALS } from "../mock";

export default function Testimonials() {
  return (
    <section className="py-20 lg:py-28 bg-[#f7faf9]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-[#16d196]">
            <span className="w-1.5 h-1.5 rounded-full bg-[#16d196]" />
            Real investors
          </div>
          <h2 className="mt-4 text-[36px] lg:text-[56px] font-extrabold leading-[1.05] tracking-[-0.025em] text-[#0d1a2e]">
            Anonymised wins from real{" "}
            <span className="text-[#16d196]">Investment Hub clients.</span>
          </h2>
          <p className="mt-5 text-[#0d1a2e]/65 text-[16.5px] leading-relaxed">
            We protect every investor's privacy by default — names are anonymised, but
            the products and amounts placed are real.
          </p>
        </div>

        <div className="mt-12 lg:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              className="bg-white border border-[#0d1a2e]/8 rounded-2xl p-6 lg:p-7 hover:border-[#16d196]/50 hover:shadow-[0_10px_30px_rgba(13,26,46,0.05)] transition-all"
            >
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-[#0d1a2e] text-white flex items-center justify-center font-extrabold text-[13.5px]">
                  {t.initials}
                </div>
                <div className="flex-1">
                  <div className="text-[13.5px] font-bold text-[#0d1a2e]">{t.name}</div>
                  <div className="text-[11.5px] text-[#0d1a2e]/55">{t.location}</div>
                </div>
                <div className="inline-flex items-center text-[10px] font-bold uppercase tracking-[0.12em] text-[#16d196] bg-[#e3f7ee] rounded-full px-2.5 py-1">
                  {t.type}
                </div>
              </div>

              <div className="mt-5 text-[28px] font-extrabold text-[#0d1a2e] tracking-[-0.02em] leading-none">
                {t.amount}
              </div>

              <p className="mt-4 text-[14.5px] text-[#0d1a2e]/70 leading-relaxed">
                “{t.quote}”
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
